export class ActionRequest<T> {
  constructor(
    /**
     * The requested action
     */
    public readonly action: string,
    /**
     * The action arguments
     */
    public readonly args: T,
  ) {}
}
